import React, { useState } from "react";
import { FootBar } from "../components/Footer";
import { useNavigate } from "react-router";
import { UserApi } from "../app/api/user.api";


export function Signup()
{
    const navigate = useNavigate();
    const user = UserApi();

    const [inputs, setInputs] = useState();
    const [status, setStatus] = useState(0);
    const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleInputs = ( event ) => {
        const { name , value } =  event.target;
        setInputs( { ...inputs, [name] : value   } );
    }

    const [checked, setChecked] = useState(false);
    const handleChange = e => setChecked(e.target.checked)
  
    const handleForm = async ( event ) => {
        event.preventDefault();
        setStatus(0);
        setIsLoading(true);
        
        if(inputs.password === inputs.cpassword )
        {   
            try {
                const {data} = await user.insert(inputs);
                setIsLoading(false);
                if(data.success){
                    setStatus(1);
                    navigate('/nouveau-compte');
                }  
                else{ 
                    setStatus(-1);
                    setMessage('Erreur, veuillez réessayer'); 
                } 
            } catch (err) { 
                setIsLoading(false);
                setStatus(-1); 
                setMessage(err?.response.data.error);
            }
        }
        else{ 
            setIsLoading(false);
            setStatus(-2); 
        }
    } 
    


    return(

        <div className="container-fluid bg-light">
            <div className="row d-flex justify-content-center px-3 pt-5">
                <div className="col-xl-7 col-lg-9 col-md-11">
                    <div className="row">
                        {/* ******************************************************************************************/}
                        <div className="col-lg-12 mb-4 d-flex justify-content-between align-items-center p-4 border rounded-3 bg-white">
                            <div className="d-flex flex-column px-2">
                                <div className="d-flex align-items-center mb-1">
                                    <span className="font-lg color-light ps-4 pe-2 py-1 rounded-start-1 bg-green" > SAMA </span>
                                    <span className="font-lg color-light bg-orange py-1 ps-2 pe-4 rounded-end-1 border-start" > DOC </span>
                                </div>
                                <span className="h3 text-muted mb-2"> Creation de compte </span>
                                <span className="text-muted font-sm"> Veuillez renseigner scrupuleusement ce formulaire avec les informations requises. </span>
                            </div>
                            <div className="p-2 bg-green rounded-2 hide-lg">
                                <img className='rounded-4 mb-3 ' src='../img/psd-8.png' height={'100px'} alt="" /> 
                            </div>
                        </div>
                        {/* ***************************************************************************************** */}
                        <div className="col-lg-12 mb-5">
                            <form className="" onSubmit={ handleForm }>
                                <div className="row mb-4">
                                    {/* -------------------------------------------------------------------- */}
                                    <div className="col-lg-12 border p-4 rounded-2 bg-white">
                                        {/* +++++++++++++++++++++++ */}
                                        <div className="row">
                                            <div className="col-md-8 mb-3">
                                                <div className="">
                                                    <label htmlFor="input1" className="text-secondary font-sm ps-1"> Prénom </label>
                                                    <div className="d-flex gap-1" >
                                                        <input type="text" name="fname" className="w-100 border input py-3 px-3 text-secondary rounded-2" placeholder="Prénom" id="input1" onChange={handleInputs} required />
                                                        <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="">
                                                    <label htmlFor="input2" className="text-secondary font-sm ps-1" > Nom </label>
                                                    <div className="d-flex gap-1" >
                                                        <input type="text" name="lname" className="w-100 border input py-3 px-3 text-secondary rounded-2" placeholder="Nom" id="input2" onChange={handleInputs} required />
                                                        <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* +++++++++++++++++++++++ */}
                                        <div className="row">
                                            <div className="col-md-8 mb-3">
                                                <div className="">
                                                    <label htmlFor="input3" className="font-sm text-secondary" > Email </label>
                                                    <div className="d-flex gap-1" >
                                                        <input type="mail" name="email" className="w-100 border input py-3 px-3 text-secondary rounded-2" placeholder="example@mail.com" id="input3" onChange={handleInputs} required/>
                                                        <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                                                    </div>   
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="">
                                                    <label htmlFor="input4" className="text-secondary font-sm"> Sexe </label>
                                                    <div className="d-flex gap-1" >
                                                        <select name="sex" id="input4" className="w-100 border input py-3 px-3 text-secondary rounded-2" onChange={handleInputs} required>
                                                            <option value=""> Choisir sexe </option>
                                                            <option value="male"> Masculin </option>
                                                            <option value="female"> Feminin </option>
                                                        </select>
                                                        <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* +++++++++++++++++++++++ */}
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <div className="">
                                                    <label htmlFor="input5" className="text-secondary font-sm ps-1"> Profession </label>
                                                    <div className="d-flex gap-1" >
                                                        <select name="occupation" id="input5" className="w-100 border input py-3 px-3 text-secondary rounded-2" onChange={handleInputs} required>
                                                            <option value=""> Choisir une profession </option>
                                                            <option value="Etudiant"> Etudiant </option>
                                                            <option value="Professeur"> Professeur </option>
                                                            <option value="Eleve"> Eleve </option>
                                                            <option value="Autres"> Autres </option>
                                                        </select>
                                                        <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <div className="">
                                                    <label htmlFor="input6" className="text-secondary font-sm ps-1"> Université </label>
                                                    <div className="d-flex gap-1" >
                                                        <select name="institut" id="input6" className="w-100 border input py-3 px-3 text-secondary rounded-2" onChange={handleInputs} required>
                                                            <option value=""> Choisir une université </option>
                                                            <option value="Universite Cheikh Anta Diop"> Universite Cheikh Anta Diop de Dakar </option>
                                                            <option value="Universite Gaston berger"> Universite Gaston berger de Saint Louis </option>
                                                            <option value="Universite Sine Saloum Elhadji Ibrahima Niass"> Universite Sine Saloum Elhadji Ibrahima Niass </option>
                                                            <option value="Universite Iba Der Thiam"> Universite Iba Der Thiam de Thies </option>
                                                            <option value="Universite Assane Seck de Ziguinchor"> Universite Assane Seck de Ziguinchor </option>
                                                            <option value="Universite Cheikh Hamidou Kane"> Universite Cheikh Hamidou Kane du Senegal</option>
                                                            <option value="Universite Amadou Makhtar Mbow de Diamiadio"> Universite Amadou Makhtar Mbow de Diamiadio </option>
                                                            <option value="Autres universite"> Autres instituts universitaires </option>
                                                        </select>
                                                        <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* +++++++++++++++++++++++ */}
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <div className="">
                                                    <label htmlFor="input7" className="text-secondary font-sm ps-1"> Mot de passe </label>
                                                    <div className="d-flex gap-1" >
                                                        <input type={showPassword ? "text" : "password"} name="password" className="w-100 border input py-3 px-3 text-secondary rounded-2" id="input7" onChange={handleInputs} required />
                                                        <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <div className="">
                                                    <label htmlFor="input8" className="text-secondary font-sm ps-1"> Confirmation mot de passe </label>
                                                    <div className="d-flex gap-1" >
                                                         <input type={showPassword ? "text" : "password"} name="cpassword" className="w-100 border input py-3 px-3 text-secondary rounded-2" id="input8" onChange={handleInputs} required />
                                                        <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12 mb-3"> 
                                                <div>
                                                   <span className="d-flex align-items-center border p-3 rounded-2 text-secondary" style={{ cursor: "pointer" }} onClick={() => setShowPassword(!showPassword)}>
                                                     <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i> Voir le mot de passe
                                                   </span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 mb-3"> 
                                                <div className="d-flex align-items-center gap-2 mb-2" >
                                                  <input type="checkbox" name="checker" checked={checked} style={{ width:'20px', height:'20px' }} className="border text-muted checkbox" onChange={ handleChange } required />
                                                  <span className="d-flex align-items-center gap-2 text-secondary"> 
                                                    <span> J'accepte les  </span>  
                                                    <a href="/condition-utilisation" target="outlet" className="nav-link text-blue-clr"> conditions d'utilisation <i className="bi bi-arrow-right"></i></a>
                                                    <span> de Samadoc </span> 
                                                    </span> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    {
                                      isLoading && (
                                        <div className="col-lg-12 d-flex justify-content-center align-items-center mb-4"> 
                                          <div className="spinner-border text-success" role="status" aria-label="Chargement"></div>
                                        </div>
                                      )
                                    }
                                    {
                                      status === -1 && (
                                        <div className="col-lg-12 mb-3">
                                          <div className="alert alert-danger"> { message } </div>
                                        </div>
                                      )
                                    }
                                    {
                                      status === -2 && (
                                        <div className="col-md-12 mb-3">
                                          <div className="alert alert-danger">
                                            Erreur! Veuillez revoir votre mot de passe et la confirmation.
                                          </div>
                                        </div>
                                      )
                                    }  
                                </div>
                                   
                                <div className="row">
                                    <div className="col-12 p-4 bg-white border rounded"> 
                                        <button className="btn px-4 py-2 btn-green" type="submit" disabled={!checked}> 
                                            Enregistrer <i className="bi bi-arrow-right ms-3"></i>  
                                        </button> 
                                    </div>
                                </div>

                            </form>
                        </div>

                        {/* ***************************************************************************************** */}
                    </div>
                </div> 
                {/* ***************************************************************************************** */} 
            </div>       
            <div className="row bg-dark mt-4"> <FootBar /> </div>   
        </div>  
        
    )
}

